import { FC } from 'react';

import Script from 'next/script';

type JsonLdProps = { html: Record<string, unknown> };

export const JsonLd: FC<JsonLdProps> = ({ html }) => {
  return (
    // eslint-disable-next-line @next/next/no-before-interactive-script-outside-document
    <Script
      id="breadcrumbs-jsonld"
      type="application/ld+json"
      strategy="beforeInteractive"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          '@context': 'https://schema.org',
          ...html
        })
      }}
    />
  );
};
